import * as React from 'react'

export const Storm = () => (
  <svg
    width="70"
    height="70"
    viewBox="0 0 70 70"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_431_769)">
      <path
        d="M53.0246 13.6879H45.636L53.4647 2.39313C54.1641 1.38305 53.4398 0 52.2114 0H25.9187C25.2965 0 24.7368 0.378029 24.5042 0.955394L15.5594 23.1817C15.3704 23.6516 15.4269 24.1845 15.7105 24.6044C15.9939 25.0241 16.4673 25.2756 16.9738 25.2756H25.3937L16.819 43.1496C16.3342 44.1605 17.0718 45.3335 18.1937 45.3335H26.8468L19.9868 68.034C19.7766 68.7292 20.0862 69.4762 20.7264 69.8191C21.3683 70.163 22.1603 70.0049 22.6222 69.4456L51.4895 34.4796C52.3076 33.4895 51.603 31.9847 50.3138 31.9847H41.7942L54.2236 16.1543C55.0063 15.1583 54.2963 13.6879 53.0246 13.6879Z"
        fill="#A5C4C7"
      />
      <path
        d="M30.5181 0H25.9187C25.2965 0 24.7368 0.378029 24.5043 0.955394L15.5594 23.1817C15.3704 23.6516 15.4269 24.1845 15.7105 24.6044C15.9939 25.0241 16.4673 25.2756 16.9738 25.2756H25.3937L16.819 43.1496C16.3342 44.1605 17.0718 45.3335 18.1937 45.3335H26.8468L19.9868 68.034C19.781 68.7148 20.0744 69.4441 20.6879 69.7962C20.8299 69.6475 19.9337 71.2849 36.4772 40.3326C36.6404 40.027 36.6314 39.6583 36.4534 39.3612C36.2754 39.0641 35.9544 38.8823 35.6079 38.8823H27.7656L38.1156 20.5653C38.288 20.2602 38.2854 19.8864 38.1088 19.5835C37.9321 19.2808 37.608 19.0946 37.2574 19.0946H29.1206L37.5311 1.40876C37.6763 1.10332 37.6549 0.744847 37.4743 0.458967C37.2937 0.17336 36.9792 0 36.641 0H30.5181Z"
        fill="#BCDBDE"
      />
    </g>
    <defs>
      <clipPath id="clip0_431_769">
        <rect width="70" height="70" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
